import { useState } from 'react';
import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";
import { MetricsDateSelector } from '../filters/MetricsDateSelector';
import { METRICS_DIMENSION_OPTIONS, METRICS_DIMENSION_VALUES, METRICS_PERIOD_OPTIONS, PlotScope, PlotType } from '../filters/metricsFilterOptions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

/**
 * EvaluationReportFilterBar options
 */
export const EvaluationReportFilterBar = (props: {
    filterOptions: any,
    updateFilterOptions: any,
    filterDateOptions: any,
    setFilterDateOptions: any,
    refresh: any,
    isLoadingMetrics: boolean,
}) => {

    const handleCheckFilter = (checked: boolean, value: string, key: string = "dimension_filter_values") => {
        const filterVals = new Set([...props.filterOptions[key]]);
        if (checked) {
            filterVals.add(value);
        } else {
            filterVals.delete(value);
        }

        props.updateFilterOptions(key, Array.from(filterVals));
    }

    return (
        <>
            <Row className="metrics-sidebar-update">
                <Col md={12} className="d-grid gap-2">
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {props.refresh()}}
                        disabled={props.isLoadingMetrics}
                    >
                        {props.isLoadingMetrics ? <><FontAwesomeIcon icon={faSpinner} spin /> Loading...</> : "Update"}
                    </Button>
                </Col>
            </Row>
            <Row className="mb-4" style={{marginTop: '48px'}}>
                <Col md={12}>
                    <div className="metrics-control-title">Date Range</div>
                    <MetricsDateSelector
                        filterDateOptions={props.filterDateOptions}
                        setFilterDateOptions={props.setFilterDateOptions}
                    />
                </Col>
            </Row>
            <Row className="mt-2 mb-4">
                <Col md={12}>
                    <div className="metrics-control-title">Period</div>

                    <Form.Select className="d-flex" onChange={(e) => props.updateFilterOptions("period", e.target.value)}>
                        {
                            METRICS_PERIOD_OPTIONS.map((selectOption: any, index: number) => {
                                return (
                                    <option key={selectOption.id} selected={props.filterOptions["period"] === index} value={index}>
                                        {selectOption.name}
                                    </option>
                                )
                            })
                        }
                    </Form.Select>
                </Col>
            </Row>
        </>
    );
};
